/* eslint-disable prettier/prettier */
// eslint-disable-next-line no-unused-vars
const dev_url = "http://localhost";
// eslint-disable-next-line no-unused-vars
const dev_port = "4000";

const DO_url = "http";

const DO_port = "//142.93.222.151";

export const full_local_backend_url = "http://localhost:4000";
export const full_test_backend_url = "";
export const full_dev_backend_url = "https://dev-backend.enrollment.nexcaliber.com";
export const full_prod_backend_url = "https://backend.enrollment.nexcaliber.com";
export const full_test_server_backend_url = "https://server.benefitbridz.com/api"; // test-server

// eslint-disable-next-line no-unused-vars
export const local_url = "http://localhost";
export const local_port = "4000";

export const test_prod_url = "https";
export const test_prod_port = "";

export const dev_prod_url = "https";
export const dev_prod_port = "//dev-backend.enrollment.nexcaliber.com";

export const test_server_url = "https";
export const test_server_port = "//server.benefitbridz.com/api"; // test-server

export const prod_url = "https";
export const prod_port = "//backend.enrollment.nexcaliber.com";

// Local, Devlopment and Production Admin Portal URL
export const localAdminUrl = "http://localhost:3000";
export const testAdminUrl = "";
export const devAdminUrl = "https://dev-admin.enrollment.nexcaliber.com";
export const prodAdminUrl = "https://admin.enrollment.nexcaliber.com";
export const testServerAdminUrl = "https://server.benefitbridz.com:3000"; // test-server

// Local, Devlopment and Production Node Server URL
export const localServerUrl = "http://localhost:4000";
export const testServerUrl = "";
export const devServerUrl = "https://dev-backend.enrollment.nexcaliber.com";
export const prodServerUrl = "https://backend.enrollment.nexcaliber.com";
export const testServerServerUrl = "https://server.benefitbridz.com/api"; // test-server

// Local, Devlopment and Production Member Portal URL
export const localMemberUrl = "http://localhost:3001";
export const testMemberUrl = "";
export const devMemberPortalUrl = "https://dev-member.enrollment.nexcaliber.com";
// export const devFirebaseMemberPortalUrl = "https://member-nexcal.web.app/";
export const prodMemberPortalUrl = "https://member.enrollment.nexcaliber.com";
export const testServerMemberPortalUrl = "https://server.benefitbridz.com:3001"; // test-server

export const ADMIN_ENV: "PROD" | "DEV" | "LOCAL" | "SERVER" = "PROD";

export const ADMIN_PORTAL_LOGIN_REDIRECTION =
	String(ADMIN_ENV) === "PROD"
		? `${prodAdminUrl}/login`
		: String(ADMIN_ENV) === "DEV"
		? `${devAdminUrl}/login`
		: String(ADMIN_ENV) === "LOCAL"
		? `${localAdminUrl}/login`
		: String(ADMIN_ENV) === "SERVER"
		? `${testServerServerUrl}/login`
		: ""; // Has to change for Dev, local and prod

export const MEMBER_PORTAL_REDIRECTION =
	String(ADMIN_ENV) === "PROD"
		? prodMemberPortalUrl
		: String(ADMIN_ENV) === "DEV"
		? devMemberPortalUrl
		: String(ADMIN_ENV) === "LOCAL"
		? localMemberUrl
		: String(ADMIN_ENV) === "SERVER"
		? testServerMemberPortalUrl
		: ""; // Has to change for Dev, local and prod

export const version = "v1";

export const headers = {
	Accept: "application/json",
	"Content-Type": "application/json"
};

export const url =
	String(ADMIN_ENV) === "PROD"
		? prod_url
		: String(ADMIN_ENV) === "DEV"
		? dev_prod_url
		: String(ADMIN_ENV) === "LOCAL"
		? local_url
		: String(ADMIN_ENV) === "SERVER"
		? test_server_url
		: ""; // Has to change for Dev, local and prod

export const port =
	String(ADMIN_ENV) === "PROD"
		? prod_port
		: String(ADMIN_ENV) === "DEV"
		? dev_prod_port
		: String(ADMIN_ENV) === "LOCAL"
		? local_port
		: String(ADMIN_ENV) === "SERVER"
		? test_server_port
		: ""; // Has to change for Dev, local and prod

export const LINK = `${url}:${port}/api/v1`;

export const FILE_PORTAL_URL =
	String(ADMIN_ENV) === "PROD"
		? prodServerUrl
		: String(ADMIN_ENV) === "DEV"
		? devServerUrl
		: String(ADMIN_ENV) === "LOCAL"
		? localServerUrl
		: String(ADMIN_ENV) === "SERVER"
		? testServerServerUrl
		: ""; // Has to change for Dev, local and prod
